import { Card, Grid } from "@mui/material";
import PropTypes from "prop-types";
// import routes from "../../routes-new";
import routes from "page_routes";
import WelcomeInfoButton from "components/Buttons/WelcomeInfoButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoutButton from "components/Buttons/LogoutButton";
import SoftButton from "components/SoftComponents/SoftButton";
import { useAuth0 } from "@auth0/auth0-react";

function NavRoutes({ sidebarState }) {
    const location = useLocation();
    const { pathname } = location;

    const navigate = useNavigate();
    const { logout, isAuthenticated } = useAuth0();

    const renderRoutes = routes.filter(route => route.in_menu == true).map(function (row, key) {
        if (row.short_name == 'help') {
            return (
                <Grid item key={key} xxs={12} md={8}>
                    <Link to={row.route} style={{ textDecoration: 'none' }}>
                        <Card
                            // onClick={(e) => { navigate(row.route) }}
                            sx={{
                                height: '100%',
                                cursor: pathname == row.route ? 'normal' : 'pointer',
                                bgcolor: pathname == row.route ? 'inherit' : 'none',
                                pointerEvents: pathname == row.route ? 'none' : 'auto'
                            }}
                        >
                            <WelcomeInfoButton sidebarState={sidebarState} title={row.long_name} icon={row.icon} color={row.color} variant={row.variant} />
                        </Card>
                    </Link>
                </Grid>
            );
        }
        else if (row.short_name == 'log_out') {
            return (
                <Grid item key={key} xxs={12} md={4}>

                    <Card
                        onClick={(e) => { logout() }}
                        sx={{
                            height: '100%',
                            cursor: pathname == row.route ? 'normal' : 'pointer',
                            bgcolor: pathname == row.route ? 'inherit' : 'none',
                            pointerEvents: pathname == row.route ? 'none' : 'auto'
                        }}
                    >
                        <WelcomeInfoButton sidebarState={sidebarState} title={'Log Out'} />
                    </Card>
                </Grid>
            );
        }
        else {
            return (
                <Grid item key={key} xxs={12}>
                    <Link to={row.route} style={{ textDecoration: 'none' }}>
                        <Card
                            // onClick={(e) => { navigate(row.route) }}
                            sx={{
                                height: '100%',
                                cursor: pathname == row.route ? 'normal' : 'pointer',
                                bgcolor: pathname == row.route ? 'inherit' : 'none',
                                pointerEvents: pathname == row.route ? 'none' : 'auto'
                            }}
                        >
                            <WelcomeInfoButton sidebarState={sidebarState} title={row.long_name} icon={row.icon} color={row.color} variant={row.variant} />
                        </Card>
                    </Link>
                </Grid>
            );
        }



    });

    return (
        <Grid container spacing={2}>
            {renderRoutes}
        </Grid>
    )
}

NavRoutes.propTypes = {
    sidebarState: PropTypes.string.isRequired,
}

export default NavRoutes;